import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
export default class ParallaxContainer extends React.Component {
    constructor(props,context) {
        super(props,context);
        this.state = { scrollPos: 0 };
        this.handleScroll = this.handleScroll.bind(this);
        this._handleScroll = _.throttle(this.handleScroll,50);
    }
    getProportion() {
        return Number(this.props.pheight)/Number(this.props.pwidth)*100+"%"
    }
    componentDidMount() {
        if(window) {
            window.addEventListener("scroll",this._handleScroll);
        }
    }
    getChildContext() {
        if(typeof window === "undefined") {
		    return { parallaxCompleted: 0 };
        } else {
            
            var node = ReactDOM.findDOMNode(this);
            var elheight = parseFloat(getComputedStyle(node).height);
            var winheight = this.context.winHeight;
            
            if(winheight<0) { return { parallaxCompleted: 0 }; } 
            var rect = node.getBoundingClientRect();
            var offset = rect.top + this.state.scrollPos;
            var complete = Math.min(Math.max((this.state.scrollPos - offset + Math.min(winheight,offset))/(Math.min(winheight,offset)+elheight),0),1);
            return { parallaxCompleted: complete };
        }
	}
    handleScroll() {
        this.setState({scrollPos:window.pageYOffset});
    }
    render() {
       return(
       <div style={{
		   position:"relative",
		   width:"100%",
		   height:0,
		   paddingBottom:this.getProportion(),
		   overflow:"hidden",
		   backgroundColor:"#333",
           minHeight: this.props.minHeight
	   }}>
           {this.props.children}
       </div>);
    }
}

ParallaxContainer.contextTypes = {
    //scrollPos: React.PropTypes.number.isRequired,
    winHeight: React.PropTypes.number.isRequired
};

ParallaxContainer.childContextTypes = {
	parallaxCompleted: React.PropTypes.number.isRequired
}


// WEBPACK FOOTER //
// ./src/js/components/ParallaxContainer/ParallaxContainer.jsx